import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { StoredAccount } from 'utils/accounts';
import messages from './messages';

export interface RemoveAccountDialogProps {
  /** The account pending removal, or null when the dialog is closed. */
  account: StoredAccount | null;
  isActive: boolean;
  /** Label of the account we'd switch to after removing the active one (undefined = none left). */
  fallbackLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RemoveAccountDialog: FC<RemoveAccountDialogProps> = ({
  account,
  isActive,
  fallbackLabel,
  onConfirm,
  onCancel,
}) => {
  const { formatMessage } = useIntl();

  const body = !account
    ? null
    : !isActive
    ? formatMessage(messages.removeNonActive, { label: account.label })
    : fallbackLabel
    ? formatMessage(messages.removeActiveSwitch, { label: account.label, next: fallbackLabel })
    : formatMessage(messages.removeActiveLogout, { label: account.label });

  return (
    <Dialog open={!!account} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{formatMessage(messages.removeTitle)}</DialogTitle>
      <DialogContent>
        <Typography>{body}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="contained" color="secondary">
          {formatMessage(messages.cancel)}
        </Button>
        <Button onClick={onConfirm} variant="contained">
          {formatMessage(messages.removeCta)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
